import React from 'react';

// Phase 4 — Confidence pill rendered from provenance.confidence.
// Honest about missing data: shows neutral "no signal" when the
// provenance block is absent or the score isn't computable.
const TONES = {
  high:   { bg: '#0a4d22', fg: '#b7eecc', label: 'HIGH'   },
  medium: { bg: '#6b4c00', fg: '#fff1be', label: 'MEDIUM' },
  low:    { bg: '#6b1b1b', fg: '#f6c2c2', label: 'LOW'    },
};

export const ConfidenceBadge = ({ confidence, compact = false }) => {
  if (!confidence || typeof confidence.score !== 'number') {
    return (
      <span
        data-testid="confidence-badge-empty"
        title="No confidence block on this run"
        style={{
          fontFamily: '"JetBrains Mono", monospace',
          fontSize: '0.72rem',
          padding: '2px 8px',
          borderRadius: 14,
          background: 'var(--ux-bg-soft, #1a2530)',
          color: 'var(--ux-text-muted, #6b7785)',
          border: '1px dashed currentColor',
        }}
      >
        confidence: —
      </span>
    );
  }
  const label = (confidence.label || 'low').toLowerCase();
  const tone = TONES[label] || TONES.low;
  const factors = confidence.factors || {};
  const tooltip =
    `model_label=${factors.model_label || '—'} · ` +
    `envelope_fit=${factors.envelope_fit ?? '—'} · ` +
    `dispersion=${factors.mc_dispersion ?? '—'}`;
  return (
    <span
      data-testid={`confidence-badge-${label}`}
      title={tooltip}
      style={{
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: compact ? '0.7rem' : '0.78rem',
        fontWeight: 700,
        letterSpacing: '0.06em',
        padding: compact ? '2px 8px' : '3px 12px',
        borderRadius: 14,
        background: tone.bg,
        color: tone.fg,
      }}
    >
      {tone.label} · {confidence.score.toFixed(2)}
    </span>
  );
};

export default ConfidenceBadge;
